import { Component, OnInit } from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {AppState} from '../../../state/appState';
import {Observable} from 'rxjs';
import {UserModel} from '../../services/user/user.model';
import {OpenModalAccountSettings} from '../../../state/actions/appState.modals.actions';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Select(AppState.currentUser$) currentUser$: Observable<UserModel>;

  constructor(private store: Store) { }

  openAccountModal() {
    this.store.dispatch(new OpenModalAccountSettings());
  }
}
